import { useI18n } from '@ecom/i18n';
import { Button, Field, Input } from '@ecom/ui-kit';
import { zodResolver } from '@hookform/resolvers/zod';
import { type ReactElement } from 'react';
import { useForm } from 'react-hook-form';

import { membershipLookupFormSchema, type MembershipLookupFormValues } from '../schemas';

import { whenDefined } from '@/lib/optional-props';

/** `GET /admin/users/:userId/memberships` — an audited cross-tenant read, DEV §5's own "View cross-tenant data — ✅ (audited)". */
export function MembershipLookupForm({
  onSubmit,
  isSubmitting,
}: {
  onSubmit: (values: MembershipLookupFormValues) => void;
  isSubmitting: boolean;
}): ReactElement {
  const { t } = useI18n();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<MembershipLookupFormValues>({ resolver: zodResolver(membershipLookupFormSchema) });

  return (
    <form
      onSubmit={(event) => {
        void handleSubmit(onSubmit)(event);
      }}
      noValidate
      className="flex flex-col gap-4"
    >
      <Field label={t('admin.roles.userIdLabel')} {...whenDefined('error', errors.userId?.message)}>
        {(bind) => <Input {...bind} {...register('userId')} type="text" autoComplete="off" />}
      </Field>

      <Field
        label={t('admin.common.reasonLabel')}
        {...whenDefined('error', errors.reason?.message)}
      >
        {(bind) => (
          <textarea
            {...bind}
            {...register('reason')}
            rows={3}
            maxLength={500}
            className="ecom-input"
          />
        )}
      </Field>

      <Button type="submit" loading={isSubmitting} className="w-full">
        {t('admin.roles.lookupButton')}
      </Button>
    </form>
  );
}
